export default __webpack_public_path__ + "static/media/ImgC2.c1466109.png";